<template>
    <main>
      <business-hours-list :infinite-id="infiniteId"
                            @reload="reload" />
    </main>
  </template>
  
  <script>
  import BusinessHoursList from "@components/modules/business-hours/list/BusinessHoursList.vue";
  import EventBus from "@packages/event-bus";
  
  export default {
    components: {
      BusinessHoursList
    },
  
    data() {
      return {
        infiniteId: +new Date(),
      };
    },
    mixins: [],
  
    props: {},
  
    mounted() {
      EventBus.$on("TRACKER_LIST_MODIFIED", this.reload);
      EventBus.$on("RELOAD_TRACKER_LIST", this.reload);
    },

    beforeDestroy() {
      EventBus.$off("TRACKER_LIST_MODIFIED", this.reload);
      EventBus.$off("RELOAD_TRACKER_LIST", this.reload);
    },
  
    methods: {
      async reload() {
        this.infiniteId++;
      },
    },
  
    computed: {},
  };
  </script>
  
  <style lang="scss" scoped>
  </style>